// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Indicator__root--gQEUx {
    width: 100%;
    border-radius: 30px;
    border: 1px solid #313337;
    background-color: #1E2028;
    overflow: hidden;
    padding: 1px;
    position: relative;
}

.Indicator__activeBar--CPCAk {
    transition: width 0.25s linear;
    background: linear-gradient(90deg, #FFA300 0%, #FF5B00 174.43%);
    border-radius: 91px;
    height: 2px;
    position: relative;
    z-index: 2;
}

.Indicator__incValueBar--Wqaut {
    position: absolute;
    top: 1px;
    left: 1px;
    z-index: 1;
    border-radius: 91px;
    border: 1px solid #323540;
    transition: width 0.25s linear, background-color 0.25s ease-in-out;
}

.Indicator__incValueBar--Wqaut.Indicator__high--gzeOi {
        background-color: #5A9735;
    }

.Indicator__incValueBar--Wqaut.Indicator__medium--yNhGy {
        background-color: #FFD370;
    }

.Indicator__incValueBar--Wqaut.Indicator__low--u6c81 {
        background-color: #FF5166;
    }
`, "",{"version":3,"sources":["webpack://./src/components/Plelander/Indicator/Indicator.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,+DAA+D;IAC/D,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,yBAAyB;IACzB,kEAAkE;AAatE;;AAXI;QACI,yBAAyB;IAC7B;;AAEA;QACI,yBAAyB;IAC7B;;AAEA;QACI,yBAAyB;IAC7B","sourcesContent":[".root {\n    width: 100%;\n    border-radius: 30px;\n    border: 1px solid #313337;\n    background-color: #1E2028;\n    overflow: hidden;\n    padding: 1px;\n    position: relative;\n}\n\n.activeBar {\n    transition: width 0.25s linear;\n    background: linear-gradient(90deg, #FFA300 0%, #FF5B00 174.43%);\n    border-radius: 91px;\n    height: 2px;\n    position: relative;\n    z-index: 2;\n}\n\n.incValueBar {\n    position: absolute;\n    top: 1px;\n    left: 1px;\n    z-index: 1;\n    border-radius: 91px;\n    border: 1px solid #323540;\n    transition: width 0.25s linear, background-color 0.25s ease-in-out;\n\n    &.high {\n        background-color: #5A9735;\n    }\n\n    &.medium {\n        background-color: #FFD370;\n    }\n\n    &.low {\n        background-color: #FF5166;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Indicator__root--gQEUx`,
	"activeBar": `Indicator__activeBar--CPCAk`,
	"incValueBar": `Indicator__incValueBar--Wqaut`,
	"high": `Indicator__high--gzeOi`,
	"medium": `Indicator__medium--yNhGy`,
	"low": `Indicator__low--u6c81`
};
export default ___CSS_LOADER_EXPORT___;
